import React, { useState, useEffect, useRef ,memo} from "react";
import {ResGet} from './component/resapi'
import HeaderTwo from './HeaderTwo';
import {connect} from 'react-redux';
import {isLoading} from "./redux/actions"
import mapboxgl from "mapbox-gl";
import Div100vh from 'react-div-100vh'
mapboxgl.accessToken = "pk.eyJ1IjoicGFzdG9yMTkxMiIsImEiOiJjazFnZTl3ajUxM3A4M2hwNjUwbjRyNjZhIn0._zQYwTcqYKmtAQq42pTmnw";
mapboxgl.setRTLTextPlugin('https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',null,true );
// To allow only 1 instance of mapboxgl.Map

const Maps=memo(({isLoading})=>{
  const [allData,setAllData]= useState([])
  const mapEl = useRef(null);
  let mapRef = useRef();
  const [centerActive,setcenterActive] = useState(0)

  const initMap = (value)=>{
      var geojson = {
        type: 'FeatureCollection',
        features: []
      }
      value.forEach((data,key)=>{
        geojson.features.push({
          'type': 'Feature',
          'properties': {
          'iconSize': [50, 50]
          },
          'geometry': {
          'type': 'Point',
          'coordinates': data.latlong
          }
        })
        
      })

      // isInitialized=true;
      mapRef.current = new mapboxgl.Map({
        container: mapEl.current,
        center: value[0].latlong,
        zoom: value[0].zoom,
        attributionControl: false,
        style: "mapbox://styles/mapbox/dark-v10",
      });
      geojson.features.forEach(function(marker) {
        var el = document.createElement('div');
        el.className = 'logo';
        el.innerHTML = `<span class="logo_light clickable"></span>`
        el.addEventListener('mouseenter', function() {
          this.parentElement.parentElement.parentElement.classList.add("active");
        });
        el.addEventListener('mouseleave', function() {
          this.parentElement.parentElement.parentElement.classList.remove("active");
        });
        new mapboxgl.Marker(el)
        .setLngLat(marker.geometry.coordinates)
        .addTo(mapRef.current);
        });
  }
  useEffect(() => {
    isLoading(false)
    ResGet(`getcontact`).then(async(response)=>{
      if(response.status===200){
        await setAllData(response.data)
        if(response.data.length>0){
          await initMap(response.data)
          setTimeout(() => {
            isLoading(true)
          }, 1000);
        }
      }
    })
  },[]);
  const handelchangeBranch=(value)=>{
    mapRef.current.flyTo({ center: allData[value].latlong,zoom: allData[value].zoom});
    setcenterActive(value)
  }
  return(
    <Div100vh style={{height:"100rvh",overflow:"hidden"}}>
  <div className="bg-fixed-light">
  <HeaderTwo w={true}/>
  <div className="slider map">
    <div className="box">
    <div ref={mapEl} style={{width:"100%",height:"100%"}} />;
    {allData.map((data,key)=>
      <div className={`txt ${centerActive===key?"":"hidden"}`} key={key}>
        {data.phone.map((datap,index)=>
            <span key={index}>{datap.replace("↵","").trim()}</span>
        )}
        <span className="mt-1">
          {data.address}
        </span>
      </div>
    )}
    </div>
    <div className="setLocal">
      {allData.map((data,key)=>
        <span key={key} className={centerActive===key?"active clickable":"clickable"} onClick={()=>handelchangeBranch(key)}>{data.name}</span>
      )}
    </div>
    
  </div>
  
</div>
  </Div100vh>
  )
})

export default connect(null,{isLoading})(Maps);
